/**
 * Page Performance — API call paths (pure, no React/DOM imports).
 *
 * Turns the URL an `api` call went to into the endpoint key that is sent:
 * origin, the API base prefix (`/api/v1`), query string and hash are all
 * dropped, id segments become `:id`, and any other non-word segment (an
 * email, a token) becomes `:param` — the same rules as route keys.
 *
 *   https://api.example.com/api/v1/tasks/42?include=x  →  /tasks/:id
 */
import { applyParamRule, normalisePath } from './route-key.js'

export const MAX_API_PATH_LENGTH = 200

const ORIGIN_RE = /^[a-z][a-z0-9+.-]*:\/\/[^/?#]*/i
const DEFAULT_BASE_PATH = '/api/v1'

function stripOrigin(value) {
  return value.replace(ORIGIN_RE, '')
}

function stripPrefix(path, prefix) {
  if (!prefix || prefix === '/') return path
  if (path === prefix) return '/'
  if (path.startsWith(`${prefix}/`)) return path.slice(prefix.length)
  return path
}

export function normalizeApiPath(url, apiBase = DEFAULT_BASE_PATH) {
  let path = stripOrigin(typeof url === 'string' ? url : '')
  const cut = path.search(/[?#]/)
  if (cut !== -1) path = path.slice(0, cut)
  if (!path.startsWith('/')) path = `/${path}`

  let basePath = stripOrigin(typeof apiBase === 'string' ? apiBase : '')
  basePath = basePath.replace(/\/+$/, '')
  path = stripPrefix(path, basePath)
  if (basePath !== DEFAULT_BASE_PATH) path = stripPrefix(path, DEFAULT_BASE_PATH)

  return applyParamRule(normalisePath(path)).slice(0, MAX_API_PATH_LENGTH)
}
